import { createCaptchaService } from './captcha';
import { createChallengeService } from './challenge';
import { clearAwsWafCookie } from './utils';

const { renderAWSCaptcha, loadCaptchaError, loadCaptchaSuccess } = createCaptchaService();
const { getChallengeToken, loadChallengeError, loadChallengeSuccess } = createChallengeService();

export {
  renderAWSCaptcha,
  loadCaptchaError,
  loadCaptchaSuccess,
  getChallengeToken,
  loadChallengeSuccess,
  loadChallengeError,
  clearAwsWafCookie,
};
